import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { ImageMap } from "@qiuz/react-image-map";
import { useRouterStore, useAuthStore } from "../../stores";
import Draggable from "react-draggable";
import "./index.css";
import { setTimeout } from "timers";
import { setLocalStorage } from "../../utils";
import pageImg from "./lonelypop_game-06-min.png";
import item1 from "./lonelypop_game-03-min.png";
import item2 from "./lonelypop_game-03-min.png";
import item3 from "./lonelypop_game-03-min.png";
import item4 from "./lonelypop_game-03-min.png";
import item5 from "./lonelypop_game-03-min.png";
import item6 from "./lonelypop_game-03-min.png";
import item7 from "./lonelypop_game-03-min.png";
import prefect from "./lonelypop_game-04-min.png";
import receive from "./lonelypop_game-02-min.png";

const WelcomePage = () => {
  const { history } = useRouterStore();
  const [bingo, setBingo] = useState(false);
  const [score, seScore] = useState(0);

  const [inputRef, setInputRef] = useState<any>(null);
  const [inputRef2, setInputRef2] = useState<any>(null);
  const [inputRef3, setInputRef3] = useState<any>(null);
  const [inputRef4, setInputRef4] = useState<any>(null);
  const [inputRef5, setInputRef5] = useState<any>(null);

  const [imageScore, setimageScore] = useState(0);
  const [imageScore2, setimageScore2] = useState(0);
  const [imageScore3, setimageScore3] = useState(0);
  const [imageScore4, setimageScore4] = useState(0);
  const [imageScore5, setimageScore5] = useState(0);

  const [firsttime, setfirsttime] = useState<any>(false);
  const [firsttime2, setfirsttime2] = useState<any>(false);
  const [firsttime3, setfirsttime3] = useState<any>(false);

  const [timeDown, setTimeDown] = useState<any>(5);
  const [timeGo, setTimeGo] = useState(0);

  const [currentGroup, setCurrentGroup] = useState(-1);
  const [currentImg, setCurrentImg] = useState(-1);
  const [gameStart, setGameStart] = useState(false);

  const [currentGroup2, setCurrentGroup2] = useState(-1);
  const [currentImg2, setCurrentImg2] = useState(-1);

  const [currentGroup3, setCurrentGroup3] = useState(-1);
  const [currentImg3, setCurrentImg3] = useState(-1);

  const [currentGroup4, setCurrentGroup4] = useState(-1);
  const [currentImg4, setCurrentImg4] = useState(-1);

  const [currentGroup5, setCurrentGroup5] = useState(-1);
  const [currentImg5, setCurrentImg5] = useState(-1);

  const [translate, setTranslate] = useState({
    x: 500,
    y: 0,
  });

  const widthGroup = [
    100, 150, 200, 250, 300, 300,

    450, 550, 600, 700, 750, 800,
  ];

  const imageGroup = [item1, item2, item3, item4, item5, item6, item7];
  const imageScores = [15, 10, 10, 25, 5, 5, 20];

  const mapArea = [
    {
      left: "15%",
      top: "74%",
      height: "8%",
      width: "70%",
    },
  ];

  const onMapClick = async (area: any, index: any) => {
    switch (index) {
      // login
      case 0:
        history.push("/game/start");

        break;
    }
  };

  const ImageMapComponent = React.useMemo(
    () => (
      <ImageMap
        className="usage-map"
        src={pageImg}
        map={mapArea}
        onMapClick={onMapClick}
      />
    ),
    [mapArea, pageImg]
  );

  const handleDragMove = (e: any, ui: any) => {
    const currentX = ui.lastX;
    setTranslate({
      x: currentX < -100 ? -100 : currentX > 800 ? 800 : currentX,
      y: 0,
    });
  };

  const checkingHight = 1200;
  const checkingWidth = 350;
  const lessHeight = 300;

  useEffect(() => {
    const interval = setInterval(() => {
      const currentX = translate.x;
      if (
        inputRef &&
        typeof inputRef.getBoundingClientRect === "function" &&
        gameStart
      ) {
        const currentTop = inputRef.getBoundingClientRect().top;
        console.log("currentTop", currentTop);
        const currentWidth = widthGroup[currentGroup];

        if (currentTop >= checkingHight) {
          setCurrentGroup(-1);
        }

        if (
          currentTop >= checkingHight - lessHeight &&
          currentX + checkingWidth >= currentWidth &&
          currentX <= currentWidth
        ) {
          setCurrentGroup(-1);
          setBingo(true);
          setInputRef(null);
          seScore(score + imageScore);
          setTimeout(() => {
            setBingo(false);
          }, 500);
        }
      }
    }, 10);
    return () => clearInterval(interval);
  }, [translate, inputRef, score, imageScore]);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentX = translate.x;
      if (
        inputRef2 &&
        typeof inputRef2.getBoundingClientRect === "function" &&
        gameStart
      ) {
        const currentWidth2 = widthGroup[currentGroup2];

        const currentTop2 = inputRef2.getBoundingClientRect().top;
        if (currentTop2 >= checkingHight) {
          setCurrentGroup2(-1);
        }

        if (
          currentTop2 >= checkingHight - lessHeight &&
          currentX + checkingWidth >= currentWidth2 &&
          currentX <= currentWidth2
        ) {
          setCurrentGroup2(-1);
          setBingo(true);
          setInputRef2(null);
          seScore(score + imageScore2);
          setTimeout(() => {
            setBingo(false);
          }, 500);
        }
      }
    }, 10);
    return () => clearInterval(interval);
  }, [translate, score, inputRef2, imageScore2]);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentX = translate.x;
      if (
        inputRef3 &&
        typeof inputRef3.getBoundingClientRect === "function" &&
        gameStart
      ) {
        const currentWidth2 = widthGroup[currentGroup3];
        const currentTop3 = inputRef3.getBoundingClientRect().top;

        if (currentTop3 >= checkingHight) {
          setCurrentGroup3(-1);
        }

        if (
          currentTop3 >= checkingHight - lessHeight &&
          currentX + checkingWidth >= currentWidth2 &&
          currentX <= currentWidth2
        ) {
          setCurrentGroup3(-1);

          setBingo(true);
          setInputRef3(null);
          seScore(score + imageScore3);
          setTimeout(() => {
            setBingo(false);
          }, 500);
        }
      }
    }, 10);
    return () => clearInterval(interval);
  }, [translate, score, inputRef3, imageScore3]);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentX = translate.x;
      if (
        inputRef4 &&
        typeof inputRef4.getBoundingClientRect === "function" &&
        gameStart
      ) {
        const currentWidth4 = widthGroup[currentGroup4];
        const currentTop4 = inputRef4.getBoundingClientRect().top;

        if (currentTop4 >= checkingHight) {
          setCurrentGroup4(-1);
        }

        if (
          currentTop4 >= checkingHight - lessHeight &&
          currentX + checkingWidth >= currentWidth4 &&
          currentX <= currentWidth4
        ) {
          setCurrentGroup4(-1);

          setBingo(true);
          setInputRef4(null);
          seScore(score + imageScore4);
          setTimeout(() => {
            setBingo(false);
          }, 500);
        }
      }
    }, 10);
    return () => clearInterval(interval);
  }, [translate, score, inputRef4, imageScore4]);

  useEffect(() => {
    const interval = setInterval(() => {
      const currentX = translate.x;
      if (
        inputRef5 &&
        typeof inputRef5.getBoundingClientRect === "function" &&
        gameStart
      ) {
        const currentWidth5 = widthGroup[currentGroup5];
        const currentTop5 = inputRef5.getBoundingClientRect().top;

        if (currentTop5 >= checkingHight) {
          setCurrentGroup5(-1);
        }

        if (
          currentTop5 >= checkingHight - lessHeight &&
          currentX + checkingWidth >= currentWidth5 &&
          currentX <= currentWidth5
        ) {
          setCurrentGroup5(-1);

          setBingo(true);
          setInputRef5(null);
          seScore(score + imageScore5);
          setTimeout(() => {
            setBingo(false);
          }, 500);
        }
      }
    }, 10);
    return () => clearInterval(interval);
  }, [translate, score, inputRef5, imageScore5]);

  // end of count score

  useEffect(() => {
    const interval = setTimeout(() => {
      if (timeDown === 0) {
        setGameStart(true);
      } else {
        setTimeDown(timeDown - 1);
      }
    }, 1000);
    return () => clearTimeout(interval);
  }, [timeDown]);

  useEffect(() => {
    const interval = setTimeout(async () => {
      if (gameStart) {
        if (timeGo === 30) {
          setGameStart(false);
          setLocalStorage("score", score);
          history.push("/game/result");
        }

        setTimeGo(timeGo + 1);
      }
    }, 1000);
    return () => clearTimeout(interval);
  }, [gameStart, timeGo, score]);

  // normal
  useEffect(() => {
    const range = [0, 1, 2, 3];
    const imageRand = Math.floor(Math.random() * 6);
    const groupRand = Math.floor(Math.random() * 4);
    if (gameStart && !firsttime) {
      setCurrentGroup(range[groupRand]);
      setCurrentImg(imageRand);
      setfirsttime(true);
      setimageScore(imageScores[imageRand]);
    }

    const interval = setInterval(() => {
      if (gameStart) {
        const imageRand = Math.floor(Math.random() * 6);
        const groupRand = Math.floor(Math.random() * 4);

        setCurrentGroup(range[groupRand]);
        setCurrentImg(imageRand);
        setimageScore(imageScores[imageRand]);
      }
    }, 1700);
    return () => clearInterval(interval);
  }, [gameStart, firsttime, imageScore]);

  // fast
  useEffect(() => {
    const range = [4, 5, 6];

    const interval = setInterval(() => {
      if (gameStart) {
        const imageRand = Math.floor(Math.random() * 6);
        const groupRand = Math.floor(Math.random() * 4);

        setCurrentGroup2(range[groupRand]);
        setCurrentImg2(imageRand);
        setimageScore2(imageScores[imageRand]);
      }
    }, 1500);
    return () => clearInterval(interval);
  }, [gameStart, firsttime2, imageScore2]);

  // slow
  useEffect(() => {
    const range = [7, 8, 9];

    const interval = setInterval(() => {
      if (gameStart) {
        const imageRand = Math.floor(Math.random() * 6);
        const groupRand = Math.floor(Math.random() * 3);

        setCurrentGroup3(range[groupRand]);
        setCurrentImg3(imageRand);
        setimageScore3(imageScores[imageRand]);
      }
    }, 1900);
    return () => clearInterval(interval);
  }, [gameStart, firsttime3, imageScore3]);

  // slow2
  useEffect(() => {
    const range = [10, 11];

    const interval = setInterval(() => {
      if (gameStart) {
        const imageRand = Math.floor(Math.random() * 6);
        const groupRand = Math.floor(Math.random() * 3);

        setCurrentGroup4(range[groupRand]);
        setCurrentImg4(imageRand);
        setimageScore4(imageScores[imageRand]);
      }
    }, 2100);
    return () => clearInterval(interval);
  }, [gameStart, imageScore4]);

  // slow3
  useEffect(() => {
    const interval = setInterval(() => {
      if (gameStart) {
        const imageRand = Math.floor(Math.random() * 6);

        setCurrentGroup5(12);
        setCurrentImg5(imageRand);
        setimageScore5(imageScores[imageRand]);
      }
    }, 2000);
    return () => clearInterval(interval);
  }, [gameStart, imageScore5]);

  return (
    <div className="main_wrapper">
      <div className="landing">
        <div
          className="step step_0"
          style={{
            background: `url(${pageImg}) left top no-repeat`,
          }}
        >
          <div className="content">
            {ImageMapComponent}

            {gameStart && (
              <div
                style={{
                  position: "absolute",
                  top: "26.5%",
                  width: "100%",
                  height: "10%",
                  fontSize: "5em",
                  fontWeight: 1000,
                  color: "#ffdb0d",
                  left: "18%",
                }}
              >
                <p
                  style={{
                    WebkitTextStrokeWidth: 5,
                    WebkitTextStrokeColor: "black",
                  }}
                >
                  {score}
                </p>
              </div>
            )}
            {!gameStart && (
              <div
                style={{
                  position: "absolute",
                  top: "45%",
                  width: "100%",
                  height: "10%",
                  display: "flex",
                  justifyContent: "center",
                  fontSize: "10em",
                  fontWeight: 1000,
                  color: "#ffdb0d",
                }}
              >
                <p
                  style={{
                    WebkitTextStrokeWidth: 5,
                    WebkitTextStrokeColor: "black",
                  }}
                >
                  {timeDown}
                </p>
              </div>
            )}

            <div
              style={{
                position: "absolute",
                width: "100%",
                top: "0%",
                height: "100%",
              }}
            >
              {widthGroup.map((number, widthIndex) => {
                return imageGroup.map((image, index) => {
                  let classOne = "hide";
                  let active = false;
                  let faster = false;
                  let slow = false;
                  let slow2 = false;
                  let slow3 = false;

                  if (gameStart) {
                    if (currentGroup === widthIndex && currentImg === index) {
                      classOne = "move";
                      active = true;
                    }

                    if (currentGroup2 === widthIndex && currentImg2 === index) {
                      classOne = "move faster";
                      faster = true;
                    }

                    if (currentGroup3 === widthIndex && currentImg3 === index) {
                      classOne = "move slow";
                      slow = true;
                    }

                    if (currentGroup4 === widthIndex && currentImg4 === index) {
                      classOne = "move slow2";
                      slow2 = true;
                    }

                    if (currentGroup5 === widthIndex && currentImg5 === index) {
                      classOne = "move slow3";
                      slow3 = true;
                    }
                  }

                  return (
                    <img
                      ref={(el) => {
                        if (active) {
                          setInputRef(el);
                        }
                        if (faster) {
                          setInputRef2(el);
                        }
                        if (slow) {
                          setInputRef3(el);
                        }

                        if (slow2) {
                          setInputRef4(el);
                        }

                        if (slow3) {
                          setInputRef5(el);
                        }
                      }}
                      className={classOne}
                      style={{
                        width: "20%",
                        height: "15%",
                        position: "absolute",
                        top: 0,
                        left: number,
                      }}
                      src={`${image}`}
                    />
                  );
                });
              })}
              <Draggable
                defaultPosition={{ x: 330, y: 0 }}
                axis="x"
                onDrag={handleDragMove}
                disabled={!gameStart}
              >
                <div
                  style={{
                    // width: "40%",
                    position: "absolute",
                    bottom: 0,
                    transform: `translateX(${translate.x}px) translateY(${translate.y}px)`,
                  }}
                >
                  <img
                    src={`${prefect}`}
                    style={{
                      position: "absolute",
                      left: -50,
                      top: "2%",
                      display: bingo ? "block" : "none",
                    }}
                  />

                  <img src={`${receive}`} />
                </div>
              </Draggable>

              <div
                style={{
                  width: "100%",
                  position: "absolute",
                  top: "26.8%",
                  left: "86%",
                  fontSize: "4em",
                  fontWeight: 800,
                  color: "#ffdb0d",
                }}
              >
                <p
                  style={{
                    WebkitTextStrokeWidth: 5,
                    WebkitTextStrokeColor: "black",
                  }}
                >
                  {30 - timeGo}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(WelcomePage);
